(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-claim/assets/voucher-input.js') >= 0) return;  svs.modules.push('/modules/tickets-claim/assets/voucher-input.js');

'use strict';

const Input = svs.ui.form.Input;
const VoucherInput = _ref => {
  let {
    id,
    label,
    onChange,
    onBlur,
    value,
    inputError,
    infotext,
    classes,
    type,
    onKeyUp,
    maxLength,
    min,
    max
  } = _ref;
  const inputValue = value || '';
  const handleInputChange = e => {
    e && e.preventDefault();
    const value = e.target.value;
    onChange && onChange(value);
  };
  const handleInputBlur = e => {
    e && e.preventDefault();
    onBlur && onBlur();
  };
  const containerClassName = "control-group voucher-input".concat(inputError ? ' error' : '');
  return React.createElement("div", {
    className: containerClassName
  }, label && React.createElement("label", null, label), React.createElement(Input, {
    className: "qa-voucher-input ".concat(classes),
    id: id,
    max: max || '10',
    maxLength: maxLength,
    min: min || '1',
    onBlur: handleInputBlur,
    onChange: handleInputChange,
    onKeyUp: onKeyUp,
    type: type,
    value: inputValue
  }), React.createElement("div", {
    className: "voucher-input-info-text"
  }, infotext && !inputError && React.createElement("span", {
    className: "qa-info-text align-left"
  }, infotext ? infotext : ''), inputError && React.createElement("span", {
    className: "error-message"
  }, inputError)));
};
setGlobal('svs.ticketsRedeem.VoucherInput', VoucherInput);

 })(window);